import {
    mapGetters,
    mapActions
  } from "vuex";

export default{
    computed: {
        ...mapGetters(["alladminrights"]),
    },
    methods: {          
        AuthsRemedialRights({remedial,check}) {            
            if(!remedial)
              return false
    
            let {business} = remedial 
            if(this.alladminrights[business.id] && this.alladminrights[business.id][check])
                return true
            return false 
        },
        AuthsAllBusinessRightCheck(check) {       
            if(!this.alladminrights)
                return false
            let found = Object.keys(this.alladminrights).find((key)=>{
                let right = this.alladminrights[key]
                if(right[check])
                    return true                
            })            
            return found
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/authsMixin.js